import { ICartData } from '../../../projects/shopping-cart/cart-bridger-pay/interfaces';
import React from 'react';
import TermsAndConditions from '../../../projects/shopping-cart/cart-bridger-pay/ui/shared/terms-and-conditions';
import { getUpsellBoxStatus } from '../upsell-provider';
import ProductPriceFormat from '../../../projects/products/product-price/product-price-format';
import CartCoupon from '../../../ui/svg/shopping-cart/coupon';
import { UpsellReferrer } from '../interfaces';
import ProgressBarType4 from './progress-bar-type-4';
import ProgressBarType2 from './progress-bar-type-2/progress-bar-type-2';

/**
 * https://wavesaudio.atlassian.net/browse/MRKT-28959
 */
interface IUpsellBoxProps {
    cartData: ICartData;
    classes?: string;
    referrer: UpsellReferrer;
}

const UpsellBox = ({
   cartData,
   classes,
   referrer,
} :IUpsellBoxProps) => {

    const result = getUpsellBoxStatus(
        cartData,
        referrer,
    );

    if(!result?.isVisible || !result.result) return null;

    const isCartLastStep = referrer === UpsellReferrer.CartStep3;

    return (
        <div className={ `text-gray-700 border border-green rounded bg-green-100 px-3 py-2 flex flex-col mb-4 ${ classes ?? '' }` } role="alert">

            <div className="flex items-center">
                <div className="text-green"><CartCoupon width="27" /></div>
                <div className="flex flex-col mx-4 flex-1">Instant Savings</div>

                {
                    cartData.priceData.totalUpsellDiscount !== 0 &&
                    <div className="text-green">
                        -<ProductPriceFormat price={ cartData.priceData.totalUpsellDiscount } />
                    </div>
                }
            </div>

            <div className={ `w-full mt-3` }>

                {
                    !result.result.isAboveMaxTier &&
                    !!result.result.progressBar &&
                    result.result.upsellType === 4 &&
                    <ProgressBarType4 progressBar={ result.result.progressBar } />
                }

                {
                    result.result.upsellType === 2 &&
                    !isCartLastStep &&
                    <ProgressBarType2
                        upsellRules={ cartData?.upsellRules || [] }
                        userValue={ result.result.productsCount }
                    />
                }

                <div className={ `flex items-center justify-between gap-2 md:whitespace-nowrap flex-wrap md:flex-nowrap ${ result.result.isAboveMaxTier ? '' : 'mt-2' }` }>
                    <div
                        id="free-plugin-progress-label"
                        className="text-sm">

                        {
                            !result.result.isAboveMaxTier &&
                            <>{ result.result.text }</>
                        }
                    </div>

                    <TermsAndConditions
                        url={ cartData.upsellTCURL }
                        classes="md:ml-auto block"
                        styles={{
                            lineHeight: '1',
                            marginTop: '1px',
                        }}
                    />
                </div>
            </div>

        </div>
    )
};

export default UpsellBox;